import { render, staticRenderFns } from "./TxConfirmation.vue?vue&type=template&id=60645635&"
import script from "./TxConfirmation.vue?vue&type=script&lang=js&"
export * from "./TxConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports